import { Box, Button, CircularProgress, Drawer, Grid, IconButton } from '@mui/material';
import { ChevronLeftIcon, CloseIcon } from '../../assets/icons';
import { useGetSignedInUser } from '../../hooks/useGetSignedInUser';
import { useGuestUserFromStore } from '../../hooks/useGuestUserFromStore';
import { closeQualificationDrawer, hideBackButton } from '../../store/features/qualification/qualificationSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { AppIcon } from '../app-icon/AppIcon';
import { GuestUserQualificationForm } from './guest-user-qualification-form/GuestUserQualificationForm';
import { StudentQualificationSelectContainer } from './student-qualification-form/StudentQualificationSelectContainer';

export const QualificationFormDrawer: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen, isBackButtonVisible } = useAppSelector((state) => ({
    isDrawerOpen: state.qualification.isQualificationDrawerOpen,
    isBackButtonVisible: state.qualification.isBackButtonVisible,
  }));

  const { isSignedIn, isFetching } = useGetSignedInUser();

  const closeDrawer = () => {
    dispatch(closeQualificationDrawer());
  };
  const _hideBackButton = (): void => {
    dispatch(hideBackButton());
  };

  const { isGuestUserFetching } = useGuestUserFromStore();
  return (
    <Drawer
      anchor="right"
      PaperProps={{ sx: { py: 2.5, maxWidth: '35rem', minWidth: '20rem' } }}
      open={isDrawerOpen}
      onClose={closeDrawer}
    >
      <Box sx={{ px: 2.5 }}>
        <Grid container justifyContent="space-between" alignItems="center">
          {isBackButtonVisible && (
            <Grid item>
              <Button
                onClick={_hideBackButton}
                variant="light"
                sx={{ borderRadius: '3rem' }}
                startIcon={<AppIcon fontSize="small" Icon={ChevronLeftIcon} />}
                size="small"
                color="secondary"
              >
                Back
              </Button>
            </Grid>
          )}
          <Grid item sx={{ ml: 'auto' }}>
            <IconButton color="secondary" aria-label="Close Menu" onClick={closeDrawer}>
              <AppIcon fontSize="small" titleAccess="Close Menu" Icon={CloseIcon} />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ mt: 1 }}>
        {isSignedIn ? (
          <StudentQualificationSelectContainer />
        ) : isFetching || isGuestUserFetching ? (
          <Box sx={{ textAlign: 'center', mt: 3 }}>
            <CircularProgress size={120} />
          </Box>
        ) : (
          <GuestUserQualificationForm />
        )}
      </Box>
    </Drawer>
  );
};
